import React from "react";
import { toast } from "react-toastify";

const Home = () => {
  return (
    <div>
      <h1>Home Page</h1>
      <button onClick={() => toast.success("Welcome to Home!")}>
        Show Toast
      </button>
    </div>
  );
};

export default Home;
